import { ButtonTheme, ButtonVariantTheme } from 'framework/button/types';
import {
  field_background_theme,
  field_border_theme,
  field_color_theme,
} from 'framework/field/constants';
import { colors, font } from 'framework/theme/constants/colors';

import { font_theme } from '../theme/constants/font';

export const button_theme: Pick<ButtonTheme, 'general'> = {
  general: {
    font_family: font_theme.general.font_family,
    font_size: font_theme.general.font_size_normal,
    padding: '0px 12px',
    gap: '10px',
    border_radius: '4px',
    min_width: '70px',
  },
};

export const normal_button_theme: Omit<ButtonTheme, 'general'> = {
  background: {
    normal: colors.purple[10],
    active: colors.purple[11],
    hover: colors.purple[11],
    error: colors.purple[10],
    disabled: colors.purple[10],
  },
  border: {
    normal: `1px solid ${colors.purple[10]}`,
    active: `1px solid ${colors.purple[11]}`,
    hover: `1px solid ${colors.purple[11]}`,
    error: `1px solid ${colors.purple[10]}`,
    disabled: `1px solid ${colors.purple[10]}`,
  },
  color: {
    normal: font.dark.normal,
    active: font.dark.active,
    hover: font.dark.hover,
    error: font.dark.error,
    disabled: font.dark.normal,
  },
};

export const secondary_button_theme: Omit<ButtonTheme, 'general'> = {
  background: field_background_theme,
  border: field_border_theme,
  color: field_color_theme,
};

export const tertiary_button_theme: Omit<ButtonTheme, 'general'> = {
  background: {
    normal: colors.purple[10],
    active: colors.purple[10],
    hover: colors.purple[10],
    error: colors.purple[10],
    disabled: colors.purple[10],
  },
  border: {
    normal: `1px solid ${colors.purple[10]}`,
    active: `1px solid ${colors.purple[10]}`,
    hover: `1px solid ${colors.purple[10]}`,
    error: `1px solid ${colors.purple[10]}`,
    disabled: `1px solid ${colors.purple[10]}`,
  },
  color: {
    normal: font.dark.normal,
    active: font.dark.active,
    hover: font.dark.hover,
    error: font.dark.error,
    disabled: font.dark.disabled,
  },
};

export const transparent_button_theme: Omit<ButtonTheme, 'general'> = {
  background: {
    normal: 'transparent',
    active: 'transparent',
    hover: 'transparent',
    error: 'transparent',
    disabled: 'transparent',
  },
  border: { ...normal_button_theme.border, normal: '1px solid transparent' },
  color: normal_button_theme.color,
};

export const button_dark_theme: ButtonVariantTheme = {
  general: button_theme.general,
  normal: normal_button_theme,
  field: tertiary_button_theme,
  secondary: secondary_button_theme,
  transparent: transparent_button_theme,
};
